import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { CancellationTokenSource } from '../../../base/common/cancellation.js';
import { Emitter } from '../../../base/common/event.js';
import { KeyChord } from '../../../base/common/keyCodes.js';
import { URI } from '../../../base/common/uri.js';
import { Position } from '../core/position.js';
import { Range } from '../core/range.js';
import { Selection } from '../core/selection.js';
import { Token } from '../core/token.js';
import * as standaloneEnums from './standaloneEnums.js';
export var KeyMod = /*#__PURE__*/function () {
  function KeyMod() {
    _classCallCheck(this, KeyMod);
  }

  _createClass(KeyMod, null, [{
    key: "chord",
    value: function chord(firstPart, secondPart) {
      return KeyChord(firstPart, secondPart);
    }
  }]);

  return KeyMod;
}();
KeyMod.CtrlCmd = 2048
/* CtrlCmd */
;
KeyMod.Shift = 1024
/* Shift */
;
KeyMod.Alt = 512
/* Alt */
;
KeyMod.WinCtrl = 256
/* WinCtrl */
;
export function createMonacoBaseAPI() {
  return {
    editor: undefined,
    languages: undefined,
    CancellationTokenSource: CancellationTokenSource,
    Emitter: Emitter,
    KeyCode: standaloneEnums.KeyCode,
    KeyMod: KeyMod,
    Position: Position,
    Range: Range,
    Selection: Selection,
    SelectionDirection: standaloneEnums.SelectionDirection,
    MarkerSeverity: standaloneEnums.MarkerSeverity,
    MarkerTag: standaloneEnums.MarkerTag,
    Uri: URI,
    Token: Token
  };
}